import type { PropsWithChildren } from 'react';
import { Children } from 'react';
import styled from 'styled-components';

import { SBHorizontal } from '#src/atoms/layout/flex/index.tsx';
import { BodyL } from '#src/atoms/typography/index.tsx';
import { tabletAndAbove } from '#src/style/mediaQuery.ts';

const Line = styled.div`
  display: none;
  @media ${tabletAndAbove} {
    display: block;
    width: 100%;
    height: 1px;
    background-color: var(--c-white);
  }
`;

export const TextWithLine = ({ children }: PropsWithChildren) => {
  return (
    <SBHorizontal gap={2.5}>
      {Children.map(children, (child, i) => {
        return (
          <>
            <BodyL className="whitespace-nowrap">{child}</BodyL>
            {i === 0 && <Line />}
          </>
        );
      })}
    </SBHorizontal>
  );
};
